import {roterPre} from "@/settings";

/** 控制台（dashboard）静态路由 */
export const MERCHANT_DASHBOARD_PATH = `${roterPre}/dashboard`;

/** 登录页（对齐 EB：`${roterPre}/login` 必须在白名单） */
export const MERCHANT_LOGIN_PATHS = [`${roterPre}/login`, '/login', '/smsLogin'] as const;

export function isMerchantLoginPath(path?: string | null): boolean {
  return !!path && (MERCHANT_LOGIN_PATHS as readonly string[]).includes(path);
}
